import "./Style.scss";

import LoaderFallbackUI from "./LoaderFallbackUI";

export { LoaderFallbackUI };
